import { render, staticRenderFns } from "./SearchTopCategories.vue?vue&type=template&id=2b483841&scoped=true&"
import script from "./SearchTopCategories.vue?vue&type=script&lang=js&"
export * from "./SearchTopCategories.vue?vue&type=script&lang=js&"
import style0 from "./SearchTopCategories.vue?vue&type=style&index=0&id=2b483841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b483841",
  null
  
)

export default component.exports